import { render, staticRenderFns } from "./ModuleRequests.vue?vue&type=template&id=33bc497c"
import script from "./ModuleRequests.vue?vue&type=script&lang=js"
export * from "./ModuleRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports